import React, { useEffect } from 'react';
import i18n from '@i18next/i18n';
import { Tooltip } from '@tencent/dui/lib/components/Tooltip';

import Styles from './index.less';
import replayIcon from './img/titlebar-slide-show-replay.svg';
import currentPlayIcon from './img/titlebar-slide-show-currentpage.svg';
import remotePlayIcon from './img/titlebar-slide-show-remoteplay.svg';
import meetingRemoteIcon from './img/toolbar-add-tencent-meeting.svg';
import meetingRemotePreview from './img/titlebar-slide-show-preview.svg';

import playWithPresenterViewIcon from '@tencent/docs-design-resources/pc/svg/titlebar_slide_show_notepage.svg';
import presenterViewPreview from '@tencent/docs-design-resources/pc/svg/titlebar_slide_show_notepage_preview.svg';
import mobile from '@tencent/docs-design-resources/pc/png@3x/download_mobile@3x.png';

interface MeetingMenuItemProps {
    onClick: () => void;
}

/**
 *
 * @returns 腾讯会议本地演示菜单项-从头演示
 */
export const LocalFromBegin = () => (
    <div className={Styles['play-menu-item']}>
        <img src={replayIcon} className={Styles['play-menu-icon']}/>
        <span>{i18n.t('从头演示')}</span>
    </div>
);

/**
 *
 * @returns 腾讯会议本地演示菜单项-从当前页演示
 */
export const LocalFromCurrent = () => (
    <div className={Styles['play-menu-item']}>
        <img src={currentPlayIcon} className={Styles['play-menu-icon']}/>
        <span>{i18n.t('从当前页演示')}</span>
    </div>
);

/**
 * 手机提词器遥控器入口
 * @returns
 */
export const  MobileRemoteControl = ({ onExposure }: ItemProps) => {
    useEffect(onExposure, []);
    return (
        <div className={Styles['play-menu-item']}>
            <img src={mobile} className={Styles['play-menu-icon']}/>
            <span>
                {i18n.t('手机遥控提词')}
            </span>
        </div>
    );
};

interface ItemProps {
    /** 曝光回调；实际上是 didmount hook，没有使用 Intersection Observer */
    onExposure: () => void;
}

/** "备注视图" 即 本地演示 + 同时打开演讲者模式独立弹窗 */
export const LocalWithPresenterView = ({ onExposure }: ItemProps) => {
    useEffect(onExposure, []);

    return (
        <Tooltip
            title={
                <HoverItem title={i18n.t('用备注视图开始演示')}
                    subTitle={i18n.t('演示过程中增加备注视图窗口，可查看备注并控制演示进度。')}
                    previewImg={presenterViewPreview}
                />
            }
            placement="left"
            alignment="start"
            hoverDelay={100}
        >
            <div className={Styles['meeting-menu-content']}>
                <img src={playWithPresenterViewIcon} className={Styles['meeting-menu-item-icon']}/>
                <span>{i18n.t('备注视图')}</span>
            </div>
        </Tooltip>
    );
};

/**
 *
 * @returns 文档远程演示菜单项
 */
export const RemotePlay = () => (
    <div className={Styles['play-menu-item']}>
        <img src={remotePlayIcon} className={Styles['play-menu-icon']}/>
        <span>{i18n.t('开始远程演示')}</span>
    </div>
);

/**
 *
 * @returns 腾讯会议演示菜单项
 */
export const MeetingMenuItem = (props: MeetingMenuItemProps) => {
    const { onClick } = props;
    return (<Tooltip
        title={
            <HoverItem title={i18n.t('用腾讯会议演示文档')}
                subTitle={i18n.t('点击后可直接投屏演示文档，提高协作效率')}
                previewImg={meetingRemotePreview}
            />
        }
        placement="left"
        alignment="start"
        hoverDelay={100}
    >
        <div className={Styles['meeting-menu-content']} onClick={onClick}>
            <img src={meetingRemoteIcon} className={Styles['meeting-menu-item-icon']}/>
            { i18n.t('用腾讯会议演示') }
        </div>
    </Tooltip>
    );
};

/** hover 时弹出的详情卡片 */
export const HoverItem = ({ title, subTitle, previewImg }: { title: string; subTitle: string; previewImg: string }) => (
    <div className={Styles['meeting-hover-item-content']}>
        <div className={Styles['content-title']}>
            {title}
        </div>
        <div className={Styles['content-subtitle']}>
            {subTitle}
        </div>
        <img className={Styles['content-preview']} src={previewImg}/>
    </div>
);
